import { apiProvider } from './api';
import { router } from './router';

export const OdlozenyServis = {
	apiProvider,
	router,
};
